import { PayloadAction } from '@reduxjs/toolkit';
import createAppSlice from 'app/createAppSlice';
import type { HealthLock, HealthLockSliceType } from './types';

// Data only (standards rule 5): the fetched HealthLock details and the
// resolved SSO token URL. Loading/error come from apiSlice selectors.
const initialState: HealthLockSliceType = {
  healthLock: null,
  ssoTokenUrl: null,
};

const healthlockSlice = createAppSlice({
  name: 'healthlock',
  initialState,
  reducers: {
    setHealthLock(state, action: PayloadAction<HealthLock | null>) {
      state.healthLock = action.payload;
    },
    setSsoTokenUrl(state, action: PayloadAction<string | null>) {
      state.ssoTokenUrl = action.payload;
    },
  },
});

export const { setHealthLock, setSsoTokenUrl } = healthlockSlice.actions;

export default healthlockSlice.reducer;
